import { DialogComponent } from './_directives/dialog/dialog.component';
import { ServiceLocator } from './locater.service';
import { Settings } from './_models/settings/settings.model';
import { environment } from '../environments/environment';
import { MatDialog } from '@angular/material/dialog';
import { DialogCloseService } from './_services/dialogClose.service';

export default class Utils {

    static newGuid() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }

    static confirmationDialog(title: string, content: string, positiveKey: string, callback, showNegativeKey= true) {
        if (!ServiceLocator.injector) {
            console.error('ServiceLocator.injector is not initialized');
            callback(false);
            return;
        }
        let dialog = ServiceLocator.injector.get(MatDialog);
        let closeDialogService =ServiceLocator.injector.get(DialogCloseService);

        let dialogRef = dialog.open(DialogComponent,
            {
                closeOnNavigation: true,
                width: '350px',
                data: {
                    title: title,
                    content: content,
                    positiveKey: positiveKey,
                    showNegativeKey:showNegativeKey
                },
                disableClose: false
            });
        dialogRef.afterClosed().subscribe(result => callback(result));
        closeDialogService.emitRegisterDialog(dialogRef);
    }

    static confirmationDialogWithWidth(title: string, content: string, positiveKey: string, negativeKey: string,  showNegativeKey: boolean, width: string = "350px", callback) {
        if (!ServiceLocator.injector) {
            console.error('ServiceLocator.injector is not initialized');
            callback(false);
            return;
        }
        let dialog = ServiceLocator.injector.get(MatDialog);
        let closeDialogService =ServiceLocator.injector.get(DialogCloseService);
        let isListContent = content.indexOf("<br>") > -1;
        let contentList : Array<string> = []; 
        if(isListContent)
        {
            let tempContentList = content.split("<br>");
            content = tempContentList[0];
            for(var i = 0; i < tempContentList.length; i++)
            { 
                if(i == 0)
                {
                    content = tempContentList[i];
                    continue;
                }
                contentList.push(tempContentList[i]);
            }
        }
        let dialogRef = dialog.open(DialogComponent,
            {
                width: width,
                data: {
                    title: title,
                    content: content,
                    positiveKey: positiveKey,
                    negativeKey: negativeKey,
                    showNegativeKey: showNegativeKey,
                    isListContent : isListContent,
                    contentList : contentList
                },
                disableClose: true
            });
        dialogRef.afterClosed().subscribe(result => callback(result));
        closeDialogService.emitRegisterDialog(dialogRef);
    }
    static getNumberOfCustomersInSearchResult(): string {
        return (localStorage.getItem('settings')) ? JSON.parse((localStorage.getItem('settings'))).numberOfCustomersInSearchResult : '';
    }
    static getNumberOfItemsInSearchResult(): string {
        return (localStorage.getItem('settings')) ? JSON.parse((localStorage.getItem('settings'))).numberOfItemsInSearchResult : '';
    }
    static getLocation(): string {
        return (localStorage.getItem('settings')) ? JSON.parse((localStorage.getItem('settings'))).locationCode : '';
    }
    static getLocationDV(): string {
        return (localStorage.getItem('settings')) ? JSON.parse((localStorage.getItem('settings'))).LocationCodeDv : '';
    }
    static getShowQuantityOfAllLocations(): boolean {
        return (localStorage.getItem('settings')) ? JSON.parse((localStorage.getItem('settings'))).showQuantityOfAllLocations : false;
    }
    static saveSettings(settings: Settings) {
        localStorage.setItem('settings', JSON.stringify(settings));
    }
    static getccEmail(): string {
        return (localStorage.getItem('settings')) ? JSON.parse((localStorage.getItem('settings'))).ccEmail : '';
    }
    static isAuthenticated(): boolean {
        return sessionStorage.getItem('isAuthenticated') == 'true';
    }
    static ParseResultFromLicenseCall(input: string) {
        let output: string
        output = input;
        if (input.trim() == "LICENSE COUNT EXCEEDED") {
            output = "License count exceeded. To continue using the app, contact your administrator to ensure there are enough licenses available before retrying.";

        }
        else if (input.trim() == "REQUIRES NAME/ADDRESS EXTENDED OPTION 12") {

            output = "REQUIRES NAME/ADDRESS EXTENDED OPTION 12.";
        }
        else if (input.trim() == "LICENSE RELEASED") {
            output = "LICENSE RELEASED.";
        }

        else if (input.trim() == "LICENSE EXPIRED") {
            output = "Your licenses is expired. Please contact your administrator for assistance.";
        }

        else if (input.trim().toUpperCase().includes("INVALID USER ID")) {
            output = "Please provide a correct AGRIS Username or AGRIS Password.";
        }

        else if (input.trim().toUpperCase().includes("INVALID PASSWORD")) {
            output = "Please provide a correct AGRIS Username or AGRIS Password.";
        }

        return output;
    }
    static GetSalesReviewRemoteServer(): string {
        return environment.SalesReviewRemoteServer;
    }
    static GetConfigurationRemoteServer(): string {
        return environment.ConfigurationRemoteServer;
    }

    static GetStagingRemoteServer(): string {
        return environment.StagingRemoteServer;
    }
    static GetGetwayRemoteServer(): string {
        return environment.GetwayRemoteServer;
    }
    static GetGetwayRemoteDomain(): string {
        return environment.GetwayRemoteServer.replace(/^https?:\/\//, '').replace(/\/$/, '');
    }
    static GetSEsignRemoteServer(): string {
        return environment.StagingRemoteServer;
    }
    static GetActionListClientAudience(): string {
        return environment.ActionListClient_Audience;
    }
    static GetEsignClientAudience(): string {
        return environment.EsignClient_Audience;
    }
    static GetBookingClientAudience(): string {
        return environment.BookingClient_Audience;
    }
    static GetBookingClientID(): string {
        return environment.BookingClient_ID;
    }
    static GetBookingClientSceret(): string {
        return environment.BookingClient_Sceret;
    }


    static GetBas64ImageSize( base64Image :String ): Number {
       // const base64Image = 'data;image/png;base64, ... ';
        const Base64SubString = base64Image.substring(base64Image.indexOf(',') + 1);
        const bits = Base64SubString.length * 6; // 567146
        const bytes = bits / 8;
        const kb = Math.ceil(bytes / 1000);
        // in one Line
       // const kb = ceil( ( (yourBase64String.length * 6) / 8) / 1000 ); // 426 kb
       return kb ;
    }
    static getUniqueObjects(array1: any[], array2: any[]): any[] {
        // Concatenate the two arrays
        const combinedArray = array1.concat(array2);
        
        // Create a map to store unique objects based on their id
        const uniqueMap = new Map<number, any>();
        
        // Iterate over each object in the combined array
        combinedArray.forEach(obj => {
            // Check if the object's id already exists in the map
            if (!uniqueMap.has(obj.id)) {
                // If not, add it to the map
                uniqueMap.set(obj.id, obj);
            }
        });
        
        // Convert the map values back to an array
        const uniqueArray = Array.from(uniqueMap.values());
        
        return uniqueArray;
    }
    static formatDateWithAmPm(date: Date): string {
        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const day = date.getDate().toString().padStart(2, '0');
        
        let hours = date.getHours();
        const minutes = date.getMinutes().toString().padStart(2, '0');
        const ampm = hours >= 12 ? 'pm' : 'am';
        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
        
        const formattedTime = hours + ':' + minutes + ' ' + ampm;
        return `${year}-${month}-${day} ${formattedTime}`;
    }
    static formatAndconvertUtcToLocal(utcDateStr: string): string {
        // Parse the input string as a Date object (assuming the input is in ISO format)
        const utcDate = new Date(utcDateStr);
      
        // Get the local date components
        const localYear = utcDate.getFullYear();
        const localMonth = (utcDate.getMonth() + 1).toString().padStart(2, '0');
        const localDay = utcDate.getDate().toString().padStart(2, '0');
      
        let localHours = utcDate.getHours();
        const localMinutes = utcDate.getMinutes().toString().padStart(2, '0');
        const ampm = localHours >= 12 ? 'pm' : 'am';
        localHours = localHours % 12;
        localHours = localHours ? localHours : 12; // the hour '0' should be '12'
      
        // Format the local time
        const formattedTime = `${localHours}:${localMinutes} ${ampm}`;
        return `${localYear}-${localMonth}-${localDay} ${formattedTime}`;
      }
      static groupBy(array, key) {
        return array.reduce((result, currentValue) => {
          (result[currentValue[key]] = result[currentValue[key]] || []).push(currentValue);
          return result;
        }, {});
      }
}


